<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsCommutesDistancesCarpooling.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'CommutesDistancesCarpooling',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('compGraphicsCommutesDistancesCarpooling.alone'),
          data: [0, 0, 0]
        },
        {
          name: this.$t('compGraphicsCommutesDistancesCarpooling.two'),
          data: [0, 0, 0]
        },
        {
          name: this.$t('compGraphicsCommutesDistancesCarpooling.threeandmore'),
          data: [0, 0, 0]
        }
      ]
      for (let commute of this.ghgi.commutes) {
        if (!commute.cdeleted) {
          for (let section of commute.sections) {
            if (section.mode === 'car') {
              let index = section.pooling - 1
              if (section.pooling >= 3) {
                index = 2
              }
              let nday = commute.nWorkingDay1
              if (section.isDay2) {
                nday = commute.nWorkingDay2
              }
              if (section.distance > 0 && section.distance < 20) {
                series[index].data[0] += nday
              } else if (section.distance >= 20 && section.distance < 50) {
                series[index].data[1] += nday
              } else if (section.distance >= 50) {
                series[index].data[2] += nday
              }
            }
          }
        }
      }
      return series
    },
    categories: function () {
      return [
        this.$t('compGraphicsCommutesDistancesCarpooling.less20km'),
        this.$t('compGraphicsCommutesDistancesCarpooling.20to50km'),
        this.$t('compGraphicsCommutesDistancesCarpooling.more50km')
      ]
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">\u25CF</span>{series.name}: <b>{point.y}</b> ' +
            self.$t('compGraphicsCommutesDistancesCarpooling.tooltip') +
            ' ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        yAxis: [
          {
            gridLineWidth: 0,
            title: {
              text: this.$t('compGraphicsCommutesDistancesCarpooling.label-1')
            },
            labels: {
              format: '{value}%'
            }
          }
        ],
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
